import type { RealtimeEvent } from "@/shared/api/generated/events";

// Все известные типы событий. `Record` по union из events.d.ts: новый тип на бэкенде
// не скомпилируется, пока его не добавят сюда.
const KNOWN_TYPES: Record<RealtimeEvent["type"], true> = {
  "analysis.progress": true,
  "analysis.done": true,
  "analysis.failed": true,
  "stats.updated": true,
  "friends.updated": true,
  "drills.ready": true,
  "billing.updated": true,
  "highlights.updated": true,
};

const isKnownType = (type: string): type is RealtimeEvent["type"] =>
  Object.hasOwn(KNOWN_TYPES, type);

// Данные публикации приходят как `unknown`. Проверяем только `type`: форму полей
// гарантирует бэкенд (Pydantic-модель события), TS-типы сгенерированы из неё же.
// Неизвестный тип (новое событие до обновления фронта) — `null`, событие пропускается.
export const parseRealtimeEvent = (data: unknown): RealtimeEvent | null => {
  if (typeof data !== "object" || data === null || !("type" in data)) {
    return null;
  }
  const { type } = data;
  if (typeof type !== "string" || !isKnownType(type)) {
    return null;
  }
  return data as RealtimeEvent;
};
